import { useQuery } from '@tanstack/react-query'
import { Redirect, useLocalSearchParams } from 'expo-router'
import ScreenView from '~/components/layout/ScreenView'
import { LoadingView } from '~/components/LoadingView'
import { trpc } from '~/lib/trpc'

export default function ContactRequestShortId() {
  return (
    <ScreenView>
      <ContactRequestContent />
    </ScreenView>
  )
}

function ContactRequestContent() {
  const { contactRequestShortId } = useLocalSearchParams<{
    contactRequestShortId: string
  }>()

  const { data: contactRequestId, isLoading } = useQuery(
    trpc.contacts.contactRequestId.queryOptions({
      shortId: decodeURIComponent(contactRequestShortId),
    })
  )

  if (isLoading) {
    return <LoadingView />
  }

  if (!contactRequestId && !isLoading) {
    return <Redirect href="/" />
  }

  return <Redirect href={`/contact-request/${contactRequestId}`} />
}
